import { grey } from '@mui/material/colors';
import createPalette from '@mui/material/styles/createPalette';

import { ThemeType } from '../constants';

export const white = '#ffffff';
export const black = '#000000';

// Neutral
export const neutral = {
  50: '#FAFAFA',
  100: '#F5F5F5',
  200: '#E5E5E5',
  300: '#D4D4D4',
  400: '#A3A3A3',
  500: '#737373',
  600: '#525252',
  700: '#404040',
  800: '#262626',
  900: '#171717',
  950: '#0A0A0A',
};

// prototype for the dark mode
export const darkPalette = createPalette({
  mode: ThemeType.DARK,
  common: {
    black,
    white,
  },
  primary: {
    contrastText: white,
    main: '#665CD2',
    light: '#7F75E7',
    dark: '#5248B8',
  },
  secondary: {
    contrastText: white,
    main: '#171717',
    light: '#262626',
    dark: '#0a0a0a',
  },
  tertiary: {
    contrastText: white,
    main: '#6B7280',
  },
  navigation: {
    activeBackground: neutral[700],
    background: neutral[950],
    activeContrastText: white,
    contrastText: '#9CA3AF',
  },
  success: {
    contrastText: white,
    main: '#22C55E',
    dark: '#15803D',
  },
  info: {
    contrastText: white,
    main: '#0EA5E9',
    dark: '#0369A1',
  },
  warning: {
    contrastText: white,
    main: '#F59E0B',
    dark: '#B45309',
  },
  error: {
    contrastText: white,
    main: '#EF4444',
    dark: '#B91C1C',
  },
  text: {
    primary: neutral[300],
    secondary: neutral[400],
    tertiary: neutral[400],
    disabled: '#6b7280',
  },
  background: {
    default: neutral[900],
    paper: neutral[800],
  },
  action: {
    active: neutral[700],
    disabledBackground: neutral[800],
    hover: neutral[700],
    selected: neutral[700],
  },
  aws: {
    text: '#FFD79B',
    primary: '#FF9900',
    background: '#A86500',
  },
  snowflake: {
    text: '#C7EAF7',
    primary: '#00A1D9',
    background: '#007DA8',
  },
  azure: {
    text: '#C2E0F7',
    primary: '#0078D4',
    background: '#005A9E',
  },
  divider: '#2a2a2a',
  grey,
});

// primary color based on tintsandshades 7d66ee

export const lightPalette = createPalette({
  common: {
    black,
    white,
  },
  primary: {
    contrastText: white,
    main: '#665CD2',
    light: '#7F75E7',
    dark: '#5248B8',
  },
  secondary: {
    contrastText: black,
    main: neutral[200],
    light: neutral[100],
    dark: neutral[300],
  },
  tertiary: {
    contrastText: white,
    main: neutral[400],
  },
  navigation: {
    activeBackground: neutral[200],
    background: neutral[100],
    activeContrastText: neutral[700],
    contrastText: neutral[600],
  },
  success: {
    contrastText: white,
    main: '#22C55E',
    dark: '#15803D',
  },
  info: {
    contrastText: white,
    main: '#0EA5E9',
    dark: '#0369A1',
  },
  warning: {
    contrastText: white,
    main: '#F59E0B',
    dark: '#B45309',
  },
  error: {
    contrastText: white,
    main: '#EF4444',
    dark: '#B91C1C',
  },
  text: {
    primary: neutral[800],
    secondary: neutral[700],
    tertiary: neutral[500],
    disabled: neutral[400],
  },
  background: {
    default: neutral[50],
    paper: white,
  },
  action: {
    active: neutral[100],
    hover: neutral[100],
    selected: neutral[100],
  },
  aws: {
    text: '#A86500',
    primary: '#FF9900',
    background: '#FFD79B',
  },
  snowflake: {
    text: '#007DA8',
    primary: '#00A1D9',
    background: '#C7EAF7',
  },
  azure: {
    text: '#005A9E',
    primary: '#0078D4',
    background: '#C2E0F7',
  },
  divider: neutral[200],
  grey,
});
